import type { RenderDatum } from '../../../insightRenderShapes'

/** Locale formatting only; all shares and semantic decisions arrive from the server. */
export function formatInsightDatum(datum: RenderDatum) {
  if (datum.result.state === 'unavailable') return datum.result.message
  if (datum.unit === 'money') return formatExactMoney(datum.result.value, datum.currencyCode)
  if (datum.unit === 'proportion')
    return datum.result.value.toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 1 })
  return datum.result.value.toLocaleString()
}

/** Format the reviewed four-decimal transport without coercing its value through Float64. */
function formatExactMoney(value: string, currencyCode: string) {
  const [whole, fraction] = value.split('.')
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })
  return formatter
    .formatToParts(BigInt(whole!))
    .map((part) => (part.type === 'fraction' ? fraction! : part.value))
    .join('')
}

export function insightBarEmphasis(emphasis: 'primary' | 'supporting' | undefined) {
  if (emphasis === 'primary') return 'focus' as const
  if (emphasis === 'supporting') return 'context' as const
  return 'plain' as const
}
